<template>
  <div>
    <a-row :gutter="[32, 32]" type="flex">
      <template v-if="!oferty.length">
        <a-col :xs="24" :sm="12" :lg="8" v-for="idx in 8" :key="idx">
          <T1OfferTypeCardPlaceholder />
        </a-col>
      </template>
      <template v-else>
        <a-col
          :xs="24"
          :sm="12"
          :lg="8"
          v-for="(oferta, i) in getOferty()"
          :key="i"
        >
          <T1OfferTypeCard :oferta="oferta" :cena="getCenaForOferta(oferta)" />
        </a-col>
      </template>
    </a-row>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import axios from "axios";
import T1OfferTypeCard from "./T1OfferCards/T1OfferTypeCard";
import T1OfferTypeCardPlaceholder from "./T1Placeholders/T1OfferTypeCardPlaceholder";

axios.defaults.withCredentials = false;

export default {
  data: () => ({
    url: "/getwyc.xml",
    typ: "Najpopularniejsze",
    cenyurl: "/getwycceny.xml",
    oferty: [],
    disabled: ["lato2016", "lato2017", "lato2018", "lato2019", "lato2020"],
    ceny: [],
    cenyOferta: {},
  }),
  props: {
    nntab: String,
  },
  methods: {
    isCenaForOferta(oferta) {
      if (this.cenyOferta[oferta.url]) {
        return true;
      } else {
        return false;
      }
    },
    getCenaForOferta(oferta) {
      if (this.cenyOferta[oferta.url]) {
        return this.cenyOferta[oferta.url];
      } else {
        return {};
      }
    },
    getCeny() {
      return axios
        .get(CONFIG.API_URL + this.cenyurl, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          /*alert("DATA:" + response.data);
            alert("STATUS:" + response.status);
            alert("DATA ITEMS:" + JSON.stringify(response.data));*/
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getOferty() {
      var that = this;
      return this.oferty.filter(function (elem, index) {
        if (that.disabled.includes(elem.child.nazwa)) {
          return false;
        } else {
          return true;
        }
      });
    },
    getRodzajOfertyCenyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.cenyurl;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("Grupa").each(function (index) {
            var newObj = {};
            newObj.cenamin = jQuery(this).attr("cenamin");
            newObj.grupa = jQuery(this).attr("id");
            newObj.url = jQuery(this).attr("url");
            if (newObj.cenamin !== "" && newObj.grupa === "trip") {
              arr.push(newObj);
              that.cenyOferta[newObj.url] = newObj;
            }
          });
          // console.log("items:" + arr.length);
          // console.log(arr);
          that.ceny = arr.slice(0);
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      return result;
    },
    getRodzajOfertyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.url;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function (data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("item").each(function (index) {
            var newObj = {};
            newObj.show = jQuery(this).attr("show");
            newObj.zdjecie = jQuery(this).attr("zdjecie");
            newObj.url = jQuery(this).attr("url");
            var subObj = {};
            subObj.prefix = jQuery(this).find("prefix").text();
            subObj.nazwa = jQuery(this).find("nazwa").text();
            subObj.pnazwa = jQuery(this).find("pnazwa").text();
            subObj.snazwa = jQuery(this).find("snazwa").text();
            subObj.tekstzb = jQuery(this).find("tekstzb").html();
            var ntab = jQuery(this).find("ntab").text();
            subObj.parametry = jQuery(this).find("parametry").text();
            newObj.child = subObj;
            //if (that.cenyOferta[subObj.prefix]) {
            if (that.nntab === ntab) {
              if (that.isCenaForOferta(newObj)) {
                arr.push(newObj);
              }
            }
            //}
          });
          // console.log("items:" + arr.length);
          // console.log(arr);
          that.oferty = arr.slice(0);
        },
        error: function (e) {
          console.log(e);
          console.log("Ajax Error");
        },
      });
      return result;
    },
  },
  mounted() {
    var that = this;
    this.getRodzajOfertyCenyData().then((data) => {
      //alert("OFERTY:" + JSON.stringify(data.page));
      /*this.ceny = data.page.GrupyDost;
      this.ceny.forEach(function(value) {
        var id = value.id;
        var name = value.name;
        var key = name + "=" + id;
        if (typeof value.cenamin === "string") {
          that.cenyOferta[key] = value;
        }
      });*/
      this.getRodzajOfertyData();
    });
  },
  components: {
    T1OfferTypeCard,
    T1OfferTypeCardPlaceholder,
  },
};
</script>
